import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LgaDto, StateDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-lga',
  templateUrl: './lga.component.html',
  styleUrls: ['./lga.component.scss']
})
export class LgaComponent implements OnChanges {

  @Input() lgas: LgaDto[];
  @Input() states: StateDto[];
  lgaForm: FormGroup;
  lgaFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<LgaDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredLga: Array<any> = [];
  status: boolean;
  selectedLgaId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createLgaForm();
  }

  createLgaForm() {
    this.lgaFormArray = this.fb.group({ Lgas: this.fb.array([]) });
    this.lgaForm = this.fb.group({
      LgaName: ['', Validators.required],
        StateId: this.selectedLgaId,
        id: null
    });
  }


  // method to display states
  setLga() {
    const control = this.lgaFormArray.controls.Lgas as FormArray;
    this.filteredLga.forEach((e) => {
      control.push(
        this.fb.group({
          LgaName: e.LgaName,
          StateId: e.StateId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addLga(lga: LgaDto) {
    console.log('lga');
    const control = this.lgaFormArray.controls.Lgas as FormArray;
    control.insert(
      0,
      this.fb.group({
        LgaName: lga.LgaName,
        StateId: this.selectedLgaId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.lgaFormArray.controls.Lgas as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter lga
  selectState(event: string) {
    this.filteredLga = this.lgas.filter((s) => s.StateId === event);
    this.selectedLgaId = event;
    const control = this.lgaFormArray.controls.Lgas as FormArray;

    if (this.filteredLga.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setLga();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteLga(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.lgaFormArray.controls.Lgas as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.lgas.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.lgas[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: LgaDto) {
    if(this.lgaForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.lgaFormArray.get('Lgas')['controls'][this.selectedIndex].patchValue({LgaName: formValue.LgaName});
    } else {
      this.addLga(formValue);
    }
    this.selectedIndex = null;
    this.lgaForm.reset()
  }

  onEdit(index, value: LgaDto) {
    this.selectedIndex = index;
    this.lgaForm.patchValue({LgaName: value.LgaName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.lgaForm.reset();
  }


  onSubmit(formValue: any) {
    formValue.type = 'lga';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('lga');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
